import { WithStyles } from 'decorators/withStyles';
import { IAccount } from 'interfaces/accounts';
import { PureComponent } from 'react';
import React from 'react';
import loginService from 'services/login';
import { ERROR_IMAGE } from 'settings';
interface IProps {
  account: IAccount;
  classes?: any;
}

@WithStyles(() => ({
  item: {
    display: 'flex',
    gap: '8px',
    width: '100%',
    padding: '8px 2px',
    '&:hover': {
      backgroundColor: '#eeee',
      transition: 'all 0.3s ease 0s',
      cursor: 'pointer'
    }
  },
  image: {
    width: 24,
    height: 24,
    borderRadius: 50
  },
  link: {
    color: '#242424',
    width: '100%',
    textDecoration: 'none',
    size: '14px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
  }
}))
export default class Item extends PureComponent<IProps> {
  public handleClick(userId: number) {
    loginService.switchAccount(userId).subscribe();
  }

  render() {
    const { item, image, link } = this.props.classes;
    const { account } = this.props;
    return (
      <div className={item} onClick={() => this.handleClick(account?.id)}>
        <img
          className={image}
          src={account?.photo}
          alt={account?.name}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null;
            currentTarget.src = ERROR_IMAGE;
          }}
        />
        <span className={link}>{account?.name}</span>
      </div>
    );
  }
}
